import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  search: ''
};

const keepSearchPaginationOptionSlice = createSlice({
  name: 'searchPaginationOption',
  initialState,
  reducers: {
    statusPageOption(
      _,
      action: PayloadAction<{
        currentPage: number;
        search: string;
      }>
    ) {
      return action.payload;
    }
  }
});

const { actions, reducer } = keepSearchPaginationOptionSlice;
export const { statusPageOption } = actions;
export default reducer;
